<template>
  <v-container fluid>
    <v-card class="elevation-2">
      <v-toolbar color="primary" dark flat>
        <v-icon class="mr-2">mdi-tow-truck</v-icon>
        <v-toolbar-title>Grúas</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-col cols="3" class="mr-3" v-if="$vuetify.breakpoint.mdAndUp">
          <v-text-field v-model="search" label="Buscar grúa..." prepend-inner-icon="mdi-magnify"
            hide-details clearable rounded single-line filled dense dark></v-text-field>
        </v-col>
        <v-btn icon @click="openForm(null)" title="Nueva grúa"><v-icon>mdi-plus</v-icon></v-btn>
        <v-btn icon @click="load" title="Actualizar"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="pb-0">
        <v-alert type="info" text dense>Las grúas del grupo están disponibles para todos sus dealers.</v-alert>
      </v-card-text>

      <v-data-table :headers="headers" :items="cranes" :search="search" :loading="loading" item-key="id"
        :items-per-page="10" :footer-props="{ itemsPerPageOptions: [10, 25, 50] }" no-data-text="No hay grúas">
        <template v-slot:item.dealership="{ item }">
          <v-chip x-small v-if="!item.dealership" color="primary" outlined>Todo el grupo</v-chip>
          <span v-else>{{ item.dealership.name }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn icon small color="primary" @click="openForm(item)" title="Editar"><v-icon>mdi-pencil</v-icon></v-btn>
          <v-btn icon small color="error" @click="remove(item)" title="Eliminar"><v-icon>mdi-delete</v-icon></v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" max-width="520px" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-tow-truck</v-icon>
          {{ editing ? 'Editar grúa' : 'Nueva grúa' }}
        </v-card-title>
        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid">
            <v-text-field v-model="form.company" label="Empresa *" outlined dense :rules="[required]"></v-text-field>
            <v-text-field v-model="form.cif" label="CIF" outlined dense></v-text-field>
            <v-row dense>
              <v-col cols="6"><v-text-field v-model="form.phone" label="Teléfono" outlined dense></v-text-field></v-col>
              <v-col cols="6"><v-text-field v-model="form.email" label="Email" outlined dense></v-text-field></v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" :disabled="saving">Cancelar</v-btn>
          <v-btn color="primary" :disabled="!valid" :loading="saving" @click="save">
            <v-icon left>mdi-content-save</v-icon>
            {{ editing ? 'Guardar' : 'Crear' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import GruaService from '@/services/GruaService'
import { apiData, apiError } from '@/grupo'

const emptyForm = () => ({ company: '', cif: '', phone: '', email: '' })

export default {
  name: 'GrupoGruas',

  data: () => ({
    cranes: [],
    search: '',
    loading: false,
    dialog: false,
    editing: null,
    valid: false,
    saving: false,
    form: emptyForm(),
    headers: [
      { text: 'Empresa', value: 'company' },
      { text: 'CIF', value: 'cif' },
      { text: 'Teléfono', value: 'phone' },
      { text: 'Email', value: 'email' },
      { text: 'Ámbito', value: 'dealership', sortable: false },
      { text: '', value: 'action', sortable: false, align: 'end' }
    ]
  }),

  mounted () {
    this.load()
  },

  methods: {
    required: v => !!v || 'Obligatorio',

    async load () {
      this.loading = true
      try {
        this.cranes = apiData(await GruaService.get({ 'per-page': 100 })) || []
      } catch (error) {
        this.$toast.error(apiError(error, 'No se pudieron cargar las grúas'))
      } finally {
        this.loading = false
      }
    },

    openForm (crane) {
      this.editing = crane
      this.form = crane ? { company: crane.company, cif: crane.cif, phone: crane.phone, email: crane.email } : emptyForm()
      this.dialog = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation())
    },

    async save () {
      this.saving = true
      try {
        if (this.editing) {
          await GruaService.put({ id: this.editing.id, ...this.form })
          this.$toast.success('Grúa actualizada')
        } else {
          await GruaService.post(this.form)
          this.$toast.success('Grúa creada')
        }
        this.dialog = false
        this.load()
      } catch (error) {
        this.$toast.error(apiError(error, 'No se pudo guardar la grúa'))
      } finally {
        this.saving = false
      }
    },

    async remove (crane) {
      const ok = await this.$confirm(`¿Eliminar la grúa ${crane.company}?`, { title: 'Eliminar grúa' })
      if (!ok) return
      try {
        await GruaService.delete(crane)
        this.load()
      } catch (error) {
        this.$toast.error(apiError(error, 'No se pudo eliminar la grúa'))
      }
    }
  }
}
</script>
